import React, { createContext, useContext, useState, useEffect } from 'react'
import { getRelevantAnswer } from '../../../../../../../utils/question.helper'
import { useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../../../store/selectors/text-submission-drawer.selectors'

const AnswerContext = createContext({})

export const AnswerContextProvider = ({ children, answers, question }) => {
    const focusedQuestionRubricId = useSelector(textSubmissionDrawerSelectors.focusedQuestionRubricId)
    const answer = getRelevantAnswer(answers, question, focusedQuestionRubricId)
    const [categoryIdToHighlight, setCategoryIdToHighlight] = useState(answer?.categoryId)
    const [categoryIdToPrefetch, setCategoryIdToPrefetch] = useState(null)

    useEffect(() => {
        setCategoryIdToHighlight(answer?.categoryId)
    }, [focusedQuestionRubricId, answer?.categoryId])

    return (
        <AnswerContext.Provider
            value={{
                categoryIdToHighlight,
                setCategoryIdToHighlight,
                categoryIdToPrefetch,
                setCategoryIdToPrefetch,
            }}
        >
            {children}
        </AnswerContext.Provider>
    )
}

export const useAnswerContext = () => useContext(AnswerContext)
